import {
  GET_VIEWS_REQUEST,
  GET_VIEWS_SUCCESS,
  GET_VIEWS_FAILED,
  LOGOUT,
} from 'actions';
import createReducer from './createReducer';

const INITIAL_STATE = {
  loading: false,
  loaded: false,
};

export default createReducer(INITIAL_STATE, {
  [GET_VIEWS_REQUEST]: (state) => ({ ...state, loading: true }),
  [GET_VIEWS_SUCCESS]: (state) => ({ ...state, loading: false, loaded: true }),
  [GET_VIEWS_FAILED]: (state) => ({ ...state, loading: false }),
  [LOGOUT]: () => ({ ...INITIAL_STATE }),
});
